"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_TARIFF_REQUEST_EXAMPLES = exports.addTariffLineRequestSchema = exports.activateTariffRequestSchema = void 0;
/**
 * Request contract for the 1 Tariff endpoint —
 * `TariffApplicationService.activateTariff`
 * (`backend/src/modules/financial/application/tariff.application-service.ts`,
 * frozen, Stage 5C.3). This is the ONLY Tariff Management capability
 * with an Application Service wrapper — `TariffManagementService`'s
 * `createDraftTariff`/`addLine`/`supersedeTariff` (Domain Service,
 * Stage 5C.2) have no Application Service, so no contract exists for
 * them (per this stage's own "do not invent APIs that have no backing
 * Application Service" rule) — see `FINANCIAL-API-REVIEW.md`.
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.activateTariffRequestSchema = zod_1.z.object({
    tariffId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
/**
 * ECM Phase 5 — pricing a tariff. `price` is integer PAISE, matching
 * `FinTariffLine.price` and every post-Stage-5A money column (ADR-043).
 * Lines can only be added while the tariff is DRAFT; repricing an ACTIVE
 * tariff goes through `supersedeTariff`, which is what keeps an in-force
 * corporate rate from changing under a bill that already used it.
 */
exports.addTariffLineRequestSchema = zod_1.z.object({
    tariffId: zod_1.z.string().uuid(),
    chargeId: zod_1.z.string().uuid(),
    price: zod_1.z.number().int().nonnegative(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_TARIFF_REQUEST_EXAMPLES = {
    activateTariff: {
        tariffId: '88888888-8888-8888-8888-888888888888',
    },
    addTariffLine: {
        tariffId: '88888888-8888-8888-8888-888888888888',
        chargeId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
        price: 40000,
    },
};
//# sourceMappingURL=financial-tariff.request.js.map